import { getData } from 'country-list';
import React from 'react';
import { useNavigate } from 'react-router-dom';

import { useRegistration } from './RegistrationContext';
import StepIndicator from './StepIndicator';
import MainLayout from '../common/MainLayout';

function ReviewDetails() {
  const navigate = useNavigate();
  const { registrationData } = useRegistration();

  const handleSubmit = e => {
    e.preventDefault();
    // TODO: Submit registration data
    navigate('/membership/thank-you');
  };

  return (
    <MainLayout>
      <StepIndicator currentStep={5} />

      <h2 className="text-2xl font-bold mb-8 text-hdlcc-textPrimary tracking-tight">
        Review Your Details
      </h2>

      <form onSubmit={handleSubmit} className="space-y-6">
        <div className="space-y-6">
          <section className="bg-hdlcc-mediumGray border border-hdlcc-lightGray/20 p-6 rounded-xl shadow-elevation-1">
            <h3 className="text-lg font-bold text-hdlcc-textPrimary mb-4">Personal Details</h3>
            <div className="grid grid-cols-2 gap-4">
              <div>
                <p className="text-hdlcc-textTertiary text-sm mb-1">First Name</p>
                <p className="text-hdlcc-textPrimary font-medium">{registrationData.firstName}</p>
              </div>
              <div>
                <p className="text-hdlcc-textTertiary text-sm mb-1">Last Name</p>
                <p className="text-hdlcc-textPrimary font-medium">{registrationData.lastName}</p>
              </div>
              <div>
                <p className="text-hdlcc-textTertiary text-sm mb-1">Email</p>
                <p className="text-hdlcc-textPrimary font-medium">{registrationData.email}</p>
              </div>
              <div>
                <p className="text-hdlcc-textTertiary text-sm mb-1">Phone</p>
                <p className="text-hdlcc-textPrimary font-medium">{registrationData.phone}</p>
              </div>
              <div>
                <p className="text-hdlcc-textTertiary text-sm mb-1">Date of Birth</p>
                <p className="text-hdlcc-textPrimary font-medium">{registrationData.dateOfBirth}</p>
              </div>
            </div>
          </section>

          <section className="bg-hdlcc-mediumGray border border-hdlcc-lightGray/20 p-6 rounded-xl shadow-elevation-1">
            <h3 className="text-lg font-bold text-hdlcc-textPrimary mb-4">Address</h3>
            <div className="space-y-3">
              <div>
                <p className="text-hdlcc-textTertiary text-sm mb-1">Address Line 1</p>
                <p className="text-hdlcc-textPrimary font-medium">{registrationData.address1}</p>
              </div>
              {registrationData.address2 && (
                <div>
                  <p className="text-hdlcc-textTertiary text-sm mb-1">Address Line 2</p>
                  <p className="text-hdlcc-textPrimary font-medium">{registrationData.address2}</p>
                </div>
              )}
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <p className="text-hdlcc-textTertiary text-sm mb-1">City</p>
                  <p className="text-hdlcc-textPrimary font-medium">{registrationData.city}</p>
                </div>
                {registrationData.region && (
                  <div>
                    <p className="text-hdlcc-textTertiary text-sm mb-1">
                      {registrationData.country === 'US' ? 'State' : 'County'}
                    </p>
                    <p className="text-hdlcc-textPrimary font-medium">{registrationData.region}</p>
                  </div>
                )}
                {registrationData.postcode && (
                  <div>
                    <p className="text-hdlcc-textTertiary text-sm mb-1">
                      {registrationData.country === 'US' ? 'ZIP Code' : 'Postal Code'}
                    </p>
                    <p className="text-hdlcc-textPrimary font-medium">
                      {registrationData.postcode}
                    </p>
                  </div>
                )}
                <div>
                  <p className="text-hdlcc-textTertiary text-sm mb-1">Country</p>
                  <p className="text-hdlcc-textPrimary font-medium">
                    {registrationData.country
                      ? getData().find(c => c.code === registrationData.country)?.name ||
                        registrationData.country
                      : 'United Kingdom'}
                  </p>
                </div>
              </div>
            </div>
          </section>

          <section className="bg-hdlcc-mediumGray border border-hdlcc-lightGray/20 p-6 rounded-xl shadow-elevation-1">
            <h3 className="text-lg font-bold text-hdlcc-textPrimary mb-4">Membership</h3>
            <div className="space-y-3">
              <div>
                <p className="text-hdlcc-textTertiary text-sm mb-1">Membership Type</p>
                <p className="text-hdlcc-textPrimary font-medium">
                  {registrationData.membershipType === 'individual'
                    ? 'Individual Membership'
                    : registrationData.membershipType === 'joint'
                      ? 'Joint Membership'
                      : registrationData.membershipType === 'youth'
                        ? 'Youth Membership'
                        : registrationData.membershipType}
                </p>
              </div>
              {registrationData.membershipType === 'joint' &&
                (registrationData.secondMemberFirstName ||
                  registrationData.secondMemberLastName) && (
                  <div className="grid grid-cols-2 gap-4">
                    <div>
                      <p className="text-hdlcc-textTertiary text-sm mb-1">
                        Second Member First Name
                      </p>
                      <p className="text-hdlcc-textPrimary font-medium">
                        {registrationData.secondMemberFirstName}
                      </p>
                    </div>
                    <div>
                      <p className="text-hdlcc-textTertiary text-sm mb-1">
                        Second Member Last Name
                      </p>
                      <p className="text-hdlcc-textPrimary font-medium">
                        {registrationData.secondMemberLastName}
                      </p>
                    </div>
                  </div>
                )}
            </div>
          </section>

          <section className="bg-hdlcc-mediumGray border border-hdlcc-lightGray/20 p-6 rounded-xl shadow-elevation-1">
            <h3 className="text-lg font-bold text-hdlcc-textPrimary mb-4">Payment Details</h3>
            <div className="space-y-3">
              <div>
                <p className="text-hdlcc-textTertiary text-sm mb-1">Payment Method</p>
                <p className="text-hdlcc-textPrimary font-medium">
                  {registrationData.paymentMethod === 'card' ? 'Credit/Debit Card' : 'Direct Debit'}
                </p>
              </div>
              {registrationData.paymentMethod === 'card' ? (
                <div>
                  <p className="text-hdlcc-textTertiary text-sm mb-1">Card Number</p>
                  <p className="text-hdlcc-textPrimary font-medium">
                    **** **** **** {registrationData.cardNumber?.slice(-4)}
                  </p>
                </div>
              ) : (
                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <p className="text-hdlcc-textTertiary text-sm mb-1">Account Name</p>
                    <p className="text-hdlcc-textPrimary font-medium">
                      {registrationData.accountName}
                    </p>
                  </div>
                  <div>
                    <p className="text-hdlcc-textTertiary text-sm mb-1">Sort Code</p>
                    <p className="text-hdlcc-textPrimary font-medium">
                      {registrationData.sortCode}
                    </p>
                  </div>
                  <div>
                    <p className="text-hdlcc-textTertiary text-sm mb-1">Account Number</p>
                    <p className="text-hdlcc-textPrimary font-medium">
                      ****{registrationData.accountNumber?.slice(-4)}
                    </p>
                  </div>
                </div>
              )}
            </div>
          </section>
        </div>

        <div className="mt-8 flex justify-between">
          <button
            type="button"
            onClick={() => navigate('/membership/payment')}
            className="bg-hdlcc-mediumGray border border-hdlcc-lightGray/20 text-white px-8 py-3 rounded-xl hover:bg-hdlcc-gray transition-all duration-200 font-semibold shadow-elevation-1"
          >
            Previous
          </button>
          <button
            type="submit"
            className="bg-gradient-to-r from-hdlcc-success to-hdlcc-success/80 text-white px-8 py-3 rounded-xl hover:shadow-lg transition-all duration-200 font-semibold shadow-elevation-1"
          >
            Complete Registration
          </button>
        </div>
      </form>
    </MainLayout>
  );
}

export default ReviewDetails;
